import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Product } from '../../classes/product';
import { ProductService } from '../../services/product.service';

@Component({
  selector: 'app-categories',
  templateUrl: './categories.component.html',
  styleUrls: ['./categories.component.scss']
})
export class CategoriesComponent implements OnInit {

  public products: Product[] = [];
  public collapse: boolean = true;
  currentCategory: string;
  
  @Output()
  public toggle: EventEmitter<any> = new EventEmitter();

  constructor(public productService: ProductService) { 
    this.productService.getProducts.subscribe(product => this.products = product);
  }

  ngOnInit(): void {
  }

  get filterbyCategory() {
    const category = [...new Set(this.products.map(product => product.type))]
    return category
  }

  public toggleEvent(category: string)
  {
    this.currentCategory = category;
    // this.toggle.emit('');
  }

  public isCurrentCategory(category: string)
  {
    return this.currentCategory === category;
  }

}
